import React, { Component } from 'react';

class Testimonials extends Component {
  render() {

    if(this.props.data){
      var testimonials = this.props.data.testimonials.map(function(testimonials){
        return  <li key={testimonials.user}>
            <blockquote>
               <p>{testimonials.text}</p>
               <cite>{testimonials.user}</cite>
            </blockquote>
         </li>
      })
    }

    return (
      <section id="testimonials">
      <div className="text-container">
         <div className="row">

            <div className="two columns header-col">
               <h1><span>Client Testimonials</span></h1>
            </div>

            <div className="ten columns flex-container">
                  <ul className="slides">
                      {/* {testimonials} */}
                      <blockquote>
                      <p>
                        From now on,<br />
                        Should it grow and open full, the sweet clematis<br />
                        Flower bold, but there's no need for rejoicing more<br />
                        Precious life, this life, just once, it comes just one time<br />
                        Keep it close, keep it from ever just leaving you<br />
                      </p>
                      <cite>Stem (Daimyō Asobi-hen) by Ringo Sheena</cite>
                      </blockquote>
                  </ul>
               </div>
            </div>
         </div>
   </section>
    );
  }
}

export default Testimonials;
